import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content">
         
        
        <section className="about-section">
          <p>
            Atatürk Kültür Merkezi Başkanlığının Türk kültürünü bilimsel yöntemlerle araştırmak, tanıtmak, yaymak ve bu alandaki kişi ve kuruluşları destekleyip onlarla iş birliği yapmak misyonu ve Türk kültürü araştırmalarında ulusal ve uluslararası düzeyde en yetkin Kurumlardan biri olmak; kültürümüzün temel değerlerini yaşatarak milli kültürü çağdaş medeniyetler seviyesi üzerine çıkarmak vizyonunu göz önüne alarak; &ldquo;Türk Sanatında Sanatçılar Ansiklopedisi&rdquo; başlığı altında başlangıcından Cumhuriyet dönemine kadar plastik sanatlarla sınırlı olmak üzere, Türk sanatının yayıldığı geniş bir coğrafya üzerindeki eserlerin yapımında rol almış sanatçıları kategorik olarak ayırarak (mimar, nakkaş vb. gibi) bu sanatçılar hakkında tarihî bilgilerin bir araya getirilerek sanat tarihine ve kültürel miras çalışmalarına katkıda bulunmak, başta akademi dünyası olmak üzere konuyla ilgilenen tüm çevrelere kolay ulaşılabilir ve güvenilir bir açık kaynak sağlanması amaçlanmıştır.
          </p>
          <p>
            Türk-İslâm sanatına dair Türkiye coğrafyasına yayılan mimari eserlere âit kitâbelerin derlenmesi çalışmalarına 19. yüzyılın ikinci yarısından itibaren başlanmış; kitâbelerde adları belirlenen sanatçılar ve eserleri giderek özel bir ilgi alanı hâline geldiği gibi, sanatçıların ele alındığı kimi yayınlara da konu edilegelmiştir. Bu bağlamda, Selçuklu, Beylikler ve Osmanlı çağında Türkiye coğrafyasındaki eserlerde çalıştıkları belirlenen sanatçılarla ilgili olarak A. Refik, K. Baykal, B. Brend, S. H. Gönçer, İ. H. Konyalı, L. A. Mayer, M. Meinecke, R. M. Meriç, M. Z. Oral, Y. Önge, B. Karamağaralı, M. K. Özergin, Z. Sönmez, Ş. Uzluk ve Z. Bayburtluoğlu gibi pek çok araştırmacı ve akademisyen tarafından yayımlanmış çalışmalardan meydana gelen önemli bir külliyâtın mevcut olduğu bilinmektedir.
          </p>
          <p>
            &ldquo;Türk Sanatında Sanatçılar Ansiklopedisi (TÜRKSA)&rdquo; adıyla dijital ortamda yayımlanacak ansiklopedinin ilk aşamasında Türkiye sınırları dahilinde, Selçuklu çağından 1923 yılına kadar uzanan bir tarih kesitinde adları ve/veya eserleri bilinen sanatçılara yer verilmesi planlanmıştır.
          </p>
          <p>
            Diğer yandan, eserleri üzerindeki kitâbelerde &ldquo;mimâr&rdquo;, &ldquo;ketebe&rdquo;, &ldquo;nakkaş&rdquo;, &ldquo;neccar&rdquo;, &ldquo;şâkird&rdquo;, &ldquo;kâşiger&rdquo;, &ldquo;sengtraş&rdquo;, &ldquo;haddad&rdquo; veya &ldquo;musavvir&rdquo; gibi çeşitli unvânlarıyla birlikte adlarını kullanan ya da &ldquo;amel-i&rdquo; ibâresiyle sadece adlarını zikreden sanatçılar ve eserleri kadar, adları sadece yazılı ya da kimi görsel belge ve kaynaklardan tespit edilip eserleri hakkında başkaca hiçbir bilgi bulunmayan sanatçılara da yer verilecektir.
          </p>
          <p>
            Türk Sanatında Sanatçılar Ansiklopedisi (TÜRKSA) logosu, Beyşehir Eşrefoğlu Cami&rsquo;nin ahşap minber alınlığında yer alan ma&rsquo;kıli hat ile yazılmış yazıdan esinlenilerek tasarlanmıştır. Bu tasarım; Türk sanatının tarihsel derinliğini, estetik anlayışını ve kültürel sürekliliğini simgelemektedir.
          </p>
          <p>
            Atatürk Kültür Merkezi Başkanlığı bünyesinde oluşturulan Sanat Tarihi ve Türk Sanatları Bilim ve Uygulama Kolu koordinasyonunda yürütülmekte olan Türk Sanatında Sanatçılar Ansiklopedisi (TÜRKSA), madde yazımı, bilimsel değerlendirme ve editoryal denetim aşamalarının ardından kamuoyunun erişimine açılmıştır. Bilimsel araştırma yöntemlerini açık kaynak yaklaşımı doğrultusunda okuyucuyla buluşturmaktadır. Böylece, bilginin yaygınlaştırılması ve sürdürülebilirliği sağlanmaktadır.
          </p>
          <p>
            TÜRKSA projesinin uluslararası alanda tanıtılması amacıyla uluslararası çeviri standartlarında öncelikle İngilizce çevirisinin yapılması, Kurumumuz diğer açık kaynak çalışmalarıyla birlikte yer alacağı ortak dijital bir platform uygulaması geliştirilmesi de hedeflenmektedir.
          </p>
        </section>

        <section className="about-section">
          <h2 className="project-team-title">Proje Ekibi</h2>
          <img 
            src="/images/turksa/uzunCizgi.png" 
            alt="Dekoratif çizgi" 
            className="decorative-line"
          />
          
          <div className="team-grid">
            <div className="team-column">
              <h3>Proje Yürütücüsü</h3>
              <p>Doç. Dr. Zeki ERASLAN</p>
            </div>

            <div className="team-column">
              <h3>Proje Yürütme Komisyonu</h3>
              <p>Doç. Dr. Zeki ERASLAN</p>
              <p>Dr. Ömer GÖK</p>
              <p>Evre ÇORUH</p>
              <p>Prof. Dr. Serpil BAĞCI</p>
              <p>Dr. Öğr. Üyesi Rüstem BOZER</p>
            </div>

            <div className="team-column">
              <h3>Alan Editörleri</h3>
              <p>Prof. Dr. Serpil BAĞCI</p>
              <p>Prof. Dr. Z.Kenan BİLİCİ</p>
              <p>Prof. Dr. Abdülhamit TÜFEKÇİOĞLU</p>
              <p>Doç. Dr. Muharrem ÇEKEN</p>
              <p>Dr. Öğr. Üyesi Rüstem BOZER</p>
             
            </div>

            <div className="team-column">
              <h3>Alan Editör Yardımcıları</h3>
              <p>Dr. Serhat TUNCER</p>
              <p>Arş. Gör. Ceren Tuğçe VAROL KOYUNCU</p>
              <p>Arş. Gör. Gökhan MERİÇ</p>
              <p>Arş. Gör. Serkan KILIÇ</p>
              <p>Arş. Gör. Kubilay ARPACI</p> 
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About; 